function AdPlayazFilled({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H11V2H2V16H16V7H18V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM4 14H6V7H4V14ZM8 14H10V4H8V14ZM12 14H14V10H12V14ZM14 6V4H12V2H14V0H16V2H18V4H16V6H14Z" fill=${`"${col}"`}/>
    </svg>
    `;

  return baseXml;
}

export default AdPlayazFilled;
